import { FC } from 'react';
import { useTheme } from 'styled-components';
import { AppContainerProps } from './types';

export const AppContainer: FC<AppContainerProps> = (props) => {
    const { AppContainer: ThemedAppContainer } = useTheme();

    return <ThemedAppContainer {...props} />;
};
